var map = {
	"./right-no.svg": "d166",
	"./right-no1.svg": "a9f5",
	"./right-ret.svg": "a818",
	"./right-ret1.svg": "6ca0",
	"./right-sc.svg": "3666",
	"./right-sc1.svg": "4028",
	"./right-shop.svg": "99c2",
	"./right-shop1.svg": "2f35",
	"./right-sp.svg": "b281",
	"./right-sp1.svg": "b560",
	"./right-top.svg": "a606",
	"./right-top1.svg": "d085"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5d5";